module.exports = __webpack_public_path__ + "img/banner_left.4387abbd.png";